var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    fill: "#161616",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 3 9 C 1.347656 9 0 10.347656 0 12 L 0 38 C 0 39.652344 1.347656 41 3 41 L 15.0625 41 C 15.566406 46.046875 19.824219 50 25 50 C 30.175781 50 34.433594 46.046875 34.9375 41 L 47 41 C 48.652344 41 50 39.652344 50 38 L 50 12 C 50 10.347656 48.652344 9 47 9 Z M 25 32 C 29.410156 32 33 35.589844 33 40 C 33 44.410156 29.410156 48 25 48 C 20.589844 48 17 44.410156 17 40 C 17 35.589844 20.589844 32 25 32 Z M 24 35 L 24 39 L 20 39 L 20 41 L 24 41 L 24 45 L 26 45 L 26 41 L 30 41 L 30 39 L 26 39 L 26 35 Z",
    fill: "#161616"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.dc8ec822e03a3752d38e14a3a90bec9a.svg";
export { ForwardRef as ReactComponent };